import IndustryPageTemplate from "./IndustryPageTemplate";
import { consultantsData } from "@/data/consultants";

export default function ConsultantsPage() {
  return <IndustryPageTemplate data={consultantsData} />;
}
